import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import axios from 'axios';
import { QueryClient, QueryClientProvider } from 'react-query';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { UserProvider } from './src/context/user';
import {EventType, PublicClientApplication} from "@azure/msal-browser";
import {msalConfig} from './src/config/authConfig';
import {MsalProvider} from "@azure/msal-react";
import { UrlString } from '@azure/msal-common';

//const baseUrl = 'https://idcardcatalogapi-test-oa28w.ondigitalocean.app/'; // TEST
//const baseUrl = 'https://idcardcatalogapi-3z8sb.ondigitalocean.app/'; // PRODUCTION
const baseUrl = process.env.REACT_APP_APIBASEURL;

axios.defaults.baseURL = baseUrl;
//live
//axios.defaults.baseURL = 'https://idcardcatalogapi-3z8sb.ondigitalocean.app/';
//test
// axios.defaults.baseURL = 'https://idcardcatalogapi-test-oa28w.ondigitalocean.app/';
//axios.defaults.baseURL = 'http://localhost:8080/';
//axios.defaults.headers.post['Content-Type'] = 'application/json';
//axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
//axios.defaults.headers.patch['Access-Control-Allow-Origin'] = '*';
//axios.defaults.headers.delete['Access-Control-Allow-Origin'] = '*';

axios.defaults.headers.common['Content-Type'] = 'application/json';
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = process.env.REACT_APP_BASEURL;
axios.defaults.headers.common['Access-Control-Allow-Private-Network'] = 'true';
axios.defaults.timeout = 60000;
axios.defaults.withCredentials = true;
// axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('webApiAccessToken')}`;

axios.interceptors.request.use(
config => {
  const token = localStorage.getItem("webApiAccessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    config.headers.Authorization = null;
  }
  console.log(config);
  return config;
},
err => {
  return Promise.reject(err);
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
    },
  },
});

// MSAL
const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0)
{
  const userAccount = msalInstance.getAllAccounts()[0] || null;
  msalInstance.setActiveAccount(userAccount);
}

// Optional - This will update account state if a user signs in from another tab or window
msalInstance.enableAccountStorageEvents();

msalInstance.addEventCallback((event) => {
  if ((event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS || event.eventType === EventType.LOGIN_SUCCESS) && event.payload.account) {
    console.log(event.payload.account);
    msalInstance.setActiveAccount(event.payload.account);
    localStorage.setItem("webApiAccessToken", event.payload.accessToken);
  }
});

const isAuthPopup = () => {
    const hash = window.location.hash;
    return UrlString.hashContainsKnownProperties(hash);
};

if (isAuthPopup()) {
  ReactDOM.render(<div>
    <h1>Authenticating...</h1>
  </div>, document.getElementById('root'));
} else {
  ReactDOM.render(
      <React.StrictMode>
        <Router>
          <QueryClientProvider client={queryClient}>
            <MsalProvider instance={msalInstance}>
              <UserProvider>
                <App/>
              </UserProvider>
            </MsalProvider>
          </QueryClientProvider>
        </Router>
      </React.StrictMode>,
      document.getElementById('root')
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
